<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Search</label>
              <vs-input type="text" v-model="filters['search']" class="w-full" />
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                v-on:click="filters = {}">CLEAR</vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="CHANNEL PARTNERS">
          <template slot="actions">
            <div class="flex">
              <vs-button @click.stop="onClickChannelPartnerPortal" class="mr-2" color="primary" type="border" icon-pack="feather" icon="icon-arrow-up-right">Channel Partner Portal</vs-button>
              <vs-button v-can="'view-channel-partner'" @click.stop="onClickCreate" >Create</vs-button>
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table id="suppliers-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="rm_suppliers"
              @sort="handleSort" :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th width="10%" sort-key="created_at">CREATED AT</vs-th>
                <vs-th width="10%" sort-key="code">CHANNEL PARTNER CODE</vs-th>
                <vs-th width="10%">COMPANY NAME</vs-th>
                <vs-th width="10%" class="">CHANNEL PARTNER STATUS</vs-th>
                <vs-th width="15%" class="" sort-key="status">DEMO PORTAL STATUS</vs-th>
                <vs-th width="15%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickSupplierView(data[indextr].id)" :key="indextr"
                  v-for="(tr, indextr) in data">

                  <vs-td>
                    {{ __dateTimeFormatterToDate(data[indextr].created_at ) }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].code }}
                  </vs-td>

                  <vs-td :data="data[indextr].company_name">
                    {{ data[indextr].company_name }}
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].status }}
                  </vs-td>
                  
                  <vs-td :class="data[indextr].demo_tenant_status === 'Build Complete' ? 'text-success' : ''">
                    <span class="flex">
                      <span class="mt-2">{{ data[indextr].demo_tenant_status }}</span>
                      <vx-tooltip v-if="data[indextr].demo_tenant_status === 'Build Complete'" text="Demo Portal"
                          position="left" class="ml-4">
                          <vs-button v-can="'view-demo-channel-partner-portal'" class="mr-2" @click.stop="onClickNavigateDemoPortal(data[indextr].id, data[indextr].domain)"
                            size="small" color="success" type="border" icon-pack="feather" icon="icon-arrow-up-right">Demo portal</vs-button>
                      </vx-tooltip>
                    </span>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View / Edit" position="left">
                        <vs-button class="mr-2" @click="onClickSupplierView(data[indextr].id)" size="small"
                          color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'deploy-channel-partner'" v-if="data[indextr].demo_tenant_status === 'Not Deployed'" text="Deploy demo tenant"
                        position="left">
                        <vs-button class="mr-2" @click.stop="onClickDeployTenant(data[indextr].id)"
                          size="small" color="success" type="border" icon-pack="feather" icon="icon-cpu"></vs-button>
                      </vx-tooltip>
                      <span class="flex" v-for="(status, status_index) in partners_statuses" :key="status_index">
                        <vs-button size="small" @click.stop="onClickChangeStatus(data[indextr].id, status.name)"
                          v-if="status.before_status.includes(data[indextr].status)" class="mr-2" type="border"
                          :color="status.color">
                          {{ status.label }}
                        </vs-button>
                      </span>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of"
              description-title="Records" description :description-items="descriptionItems"
              :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
            </vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <createChannelPartnerPopUp ref="createChannelPartnerPopUp" />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
const ChannelPartnerRepository = RepositoryFactory.get('channel_partner')
import { defaultPagination, perPageList } from "@/constants/config";
import CreateChannelPartnerPopUp from '@/components/popups/tenants/channel-partners/CreateChannelPartnerPopUp.vue';
import { partners_statuses } from '@/constants/statuses.js'
import { APP_LEVEL_2_URL, APP_DEMO_TENANT_AUTH_PAGE, APP_CHANNEL_PARTNER_PORTAL } from "@/constants/config";
import ErrorMessages from '@/mixins/ErrorMessages'

export default {
  name: 'ChannelPartnersList',
  data() {
    return {
      rm_suppliers: [],
      departments: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      supplier_status_list: [
        { name: 'SAQ Pending', value: 1 },
        { name: 'Pending Approval', value: 2 },
        { name: 'Approved', value: 3 },
        { name: 'Not Approved', value: 4 },
        { name: 'On Hold', value: 5 },
      ],
      tenant_id: '',
      partners_statuses: partners_statuses
    }
  },
  components: {
    'v-select': vSelect,
    CreateChannelPartnerPopUp
  },
  mixins: [Filter, ErrorMessages],
  async mounted() {
    this.tenant_id = this.$route.params.id
  },
  methods: {
    async refreshData() {
      this.loadRmSuppliers()
    },

    async loadRmSuppliers() {
      await this.$vs.loading({
        container: '#suppliers-table',
        scale: 0.45
      })
      const { data } = await ChannelPartnerRepository.getChannelPartnerList(this.page, this.filterQuery, this.perPage, this.sort)
      this.rm_suppliers = data.data
      this.meta = data.meta
      this.$vs.loading.close('#suppliers-table > .con-vs-loading')
    },
    async onClickSupplierView(id) {
      this.$router.push({ path: `/pages/channel-partners/${id}` })
    },
    async onClickDeployTenant(id) {
      try {
        await ChannelPartnerRepository.deployeDemoTenant(id)
        await this.loadRmSuppliers()
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async onClickChangeStatus(id, status_name) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm',
        text: `Are you sure you want to change partner status?`,
        accept: this.confirmStatusChange,
        parameters: [id, status_name]
      })
    },
    async confirmStatusChange(params) {
      try {
        await ChannelPartnerRepository.changePartnerStatus(params[0], params[1])
        await this.loadRmSuppliers()
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async onClickNavigateDemoPortal(id, domain) {
      try {
        const { data } = (await ChannelPartnerRepository.getDemoPortalToken(id)).data
        window.open(`https://${domain.split(".")[0]}.${APP_LEVEL_2_URL}${APP_DEMO_TENANT_AUTH_PAGE}${data.token}`)
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    onClickChannelPartnerPortal() {
      window.open(APP_CHANNEL_PARTNER_PORTAL)
    },
    filterQueryUpdate() {
      this.loadRmSuppliers()
    },

    handleChangePage(page) {
      this.page = page;
      this.loadRmSuppliers()
    },

    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.loadRmSuppliers()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    async onClickCreate() {
      await this.$refs.createChannelPartnerPopUp.openPopup()
    }

  },
  watch: {
    page() {
      this.loadRmSuppliers()
    },
    perPage() {
      this.loadRmSuppliers()
    }
  }
}
</script>
